document.addEventListener("DOMContentLoaded", () => {
  // Header typewriter
  const header = document.getElementById('store-header');
  if (header) {
    const text = header.textContent;
    header.textContent = '';
    let i = 0;
    function type() {
      if (i < text.length) {
        header.textContent += text.charAt(i);
        i++;
        setTimeout(type, 30);
      }
    }
    type();
  }

  // Add to cart with visual feedback
  const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', async () => {
      const card = button.closest('.product-card');
      const variantSelect = card.querySelector('.variant-select');
      if (!variantSelect) return;

      const variantId = variantSelect.value;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (res.ok) {
          // Trigger mobile vibration
          if (navigator.vibrate) {
            navigator.vibrate(100);
          }

          // Visual feedback on button
          const originalText = button.textContent;
          button.classList.add('added');
          button.textContent = '✔ Added!';
          setTimeout(() => {
            button.classList.remove('added');
            button.textContent = originalText;
          }, 1500);

          // Cart button pulse
          const cartBtn = document.getElementById('floating-cart-btn');
          if (cartBtn) {
            cartBtn.style.display = 'block';
            cartBtn.classList.add('pulse');
            setTimeout(() => cartBtn.classList.remove('pulse'), 3000);
          }
        }
      } catch (err) {
        console.error('Add to cart failed', err);
      }
    });
  });

  // Category filters
  const filterButtons = document.querySelectorAll('.filter-btn');
  const productCards = document.querySelectorAll('.product-card');
  filterButtons.forEach(button => {
    button.addEventListener('click', () => {
      const category = button.dataset.category.toLowerCase();
      productCards.forEach(card => {
        const tags = card.dataset.tags.toLowerCase().split(',');
        card.style.display = (category === 'all' || tags.includes(category)) ? '' : 'none';
      });
    });
  });

  // Floating cart button click
  const cartBtn = document.getElementById('floating-cart-btn');
  if (cartBtn) {
    cartBtn.addEventListener('click', () => {
      window.location.href = '/cart';
    });
  }
});
